<div
	class="experiment-controls__wrapper "
	[ngClass]="{ 'experiment-controls__wrapper--expanded': isExpanded }"
>
	<freud-card class="experiment-controls__widget">
		<div
			class="zk-flex zk-justify-between zk-w-full zk-cursor-pointer"
			(click)="toggleExpanded()"
		>
			<h1 class="experiment-controls__title zk-flex zk-gap-2 zk-items-center">
				<span class="freud-icon freud-icon-filter"></span>
				<span *ngIf="isExpanded">Experimentos em andamento</span>
			</h1>
			<span
				[ngClass]="{
					'freud-icon freud-icon-chevron-down': isExpanded,
					'freud-icon freud-icon-chevron-up': !isExpanded
				}"
			>
			</span>
		</div>
		<freud-panel-menu
			*ngIf="isExpanded"
			[styleParams]="{ width: '400px' }"
			[items]="experiments"
		>
		</freud-panel-menu>
	</freud-card>
</div>
